export class User {
    UserID: number;
    EmpCode: string;
    Email: string;
    FirstName: string;
    LastName: string;
    UserName: string;
    Password: string;
    CompanyID: number;
    LastLoginDate: string;
    Status: number;
    Lanauge: string;
    DateFormat: string;
    Theme: string;
    CurrencyFormat: string;
    CurrencyDecimalSeparator: string;
    CurrencyGroupSeparator: string;
    FormatType: string;
    RecordsPerPage: string;
    EnableTooltip: string;
    Deleted: boolean;
    CreateDate: string;
    CreateBy: string;
    CreatePcNm: string;
    UpdateDate: string;
    UpdateBy: string;
    UpdatePcNm: string;
    CompanyName: string;
    BaseCurrency: string;
    Token: string;
    IPAddress: string;
    SelectedValue: any;
    LocationID: string;
    WarehouseID: number;
    GroupID: number;
    LocationName: string;
    LocationCode: string;
    IsAdmin: boolean;
    LocationCodeName: string
    LoginID: number;
    Permission: Array<GetUserPermissionPCResult>;
}
export class UserLogin {
    UserName: string;
    Password: string;
    IPAddress: string;
}

export class ResetPasswordSentEmailModel {
    Email: string;
}

export class TokenSearchModel {
    token: string;
}

export class ResetPasswordModel {
    token: string;
    password: string;
    confirmPassword: string;

}

export class ChangePassword {
    UserID: number;
    UserName: string;
    oldPassword: string;
    newPassowrd: string;
    confirmPassowrd: string;
    user: number;
    CompanyID: number;
    URL: string;
    IPAddress: string;
}

export class GetAllUIobjectResult {
    [x: string]: any;

    constructor() {
        this.Permissions = new Array<GetUIobjectPermissionResult>();
    }
    ObjectID: string;
    ObjName: string;
    Description: string;
    ObjType: string;
    ObjTypename: string;
    View: boolean = false;
    Create: boolean = false;
    Edit: boolean = false;
    Delete: boolean = false;
    Approve: boolean;
    Permissions: Array<GetUIobjectPermissionResult>;
}

export class GetUIobjectPermissionResult {
    GroupID: number;
    ObjID: string;
    PermissionID: number;
    Description: string;
    PermissionType: number;
    PermissionName: string
    PermissionFlag: boolean;
    UpdateBy: number;
    NAME: string;
}

export class UIobjectPermissionSearch {
    ObjectID: string;
    GroupId: number;
}

export class GetGroupListSearch {
    GroupID: number;
    GroupCode: string;
    GroupName: string;
    Description: string;

}

export class Group {
    GroupID: number;
    GroupCode: string;
    GroupName: string;
    Description: string;
    CreateBy: number;
    CreateDate: string;
    CreatePcNm: string;
    UpdateBy: number;
    UpdateDate: string;
    UpdatePcNm: string;
}


export class GroupPermissionModel extends Group {
    constructor() {
        super();
        this.Permissions = new Array<GetUIobjectPermissionResult>();
    }
    Permissions: Array<GetUIobjectPermissionResult>;
}

export class GetLoginHistoryResult {
    LoginID: number;
    UserID: number;
    UserName: string;
    Email: string;
    LoginDate: string;
    LogOutDate: string;
    IPAddress: string;
    SessionID: string;
    SuccessFlag: boolean;
    Error: string;
}


export class GetUserPermissionPCResult {
    GroupID: number;
    ObjID: string;
    ObjName: number;
    PermissionID: string;
    Permissionflag: boolean;
    ObjType: string;
    Description: string;
}


export class MST_USER {
    USER_ID: number;
    USERNAME: string;
    PASSWORD: string;
    FIRSTNAME: string;
    LASTNAME: string;
    PHONE: string;
    EMAIL: string;
    IMG_PROFILE_URL: string;
    BRANCH_ID: number;
    ROLE_ID: number;
    STATUS: number;
    DELETED: number;
    CREATE_BY: string;
    CREATE_DATE: string;
    UPDATE_BY: string;
    UPDATE_DATE: string;
    IS_ADMIN: boolean;
    Permission: GetUserPermissionPCResult[];
    IPAddress: string;
    ImagePath: string;
    confirmPassowrd: string;
    fileAndImage: FormData;
    deletePictureFlag: boolean;
}



// WEBPACK FOOTER //
// ./src/app/model/user.model.ts